import React, { createContext, useContext, useEffect, useRef } from 'react';
import usePersistedState from '../hooks/usePersistedState';
import { useAuthContext } from './AuthContext';

const defaultUserProfileContext = {
  profile: null,
  setProfile: () => {},
  family: null,
  setFamily: () => {},
};

const UserProfileContext = createContext(defaultUserProfileContext);

export const useUserProfileContext = () => useContext(UserProfileContext);

export const UserProfileProvider = ({ children }) => {
  const { user } = useAuthContext() || {};
  const userScope = user?._id || user?.id || user?.userId || 'guest';
  const [profile, setProfile] = usePersistedState('userProfile', null, {
    scopeKey: userScope,
    area: 'session',
  });
  const [family, setFamily] = usePersistedState('familyInfo', null, {
    scopeKey: userScope,
    area: 'session',
  });
  const prevUserIdRef = useRef(null);

  useEffect(() => {
    const currentUserId = user?._id || user?.id || user?.userId || null;
    const prevUserId = prevUserIdRef.current;

    if (prevUserId && currentUserId && currentUserId !== prevUserId) {
      setProfile(null);
      setFamily(null);
    } else if (prevUserId && !currentUserId) {
      setProfile(null);
      setFamily(null);
    }

    prevUserIdRef.current = currentUserId;
  }, [user, setProfile, setFamily]);

  return (
    <UserProfileContext.Provider
      value={{ profile, setProfile, family, setFamily }}
    >
      {children}
    </UserProfileContext.Provider>
  );
};
